import { Component, Input } from '@angular/core';
import { WikiLinkEnum } from '../../../../models/enums/wiki-link.enum';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-wiki-link',
  templateUrl: './bary-wiki-link.component.html',
  styleUrls: ['./bary-wiki-link.component.scss'],
  standalone: true,
  imports: [TranslateDirective, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryWikiLinkComponent {
  @Input() link!: WikiLinkEnum;

  protected readonly FAS = FaDirectiveEnum.FAS;
}
